<div class="container">
  <mat-toolbar class="toolbar">

    <button mat-icon-button (click)="snav.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <h1>Tumsa Reclutamiento</h1>

    <div style="display: flex; justify-content: center;">
      <button style="align-self: center; justify-self: center;" mat-icon-button (click)="newUser()">
        <mat-icon>perm_identity</mat-icon>
      </button>
      <a style="color: rgb(255, 255, 255); align-self: center; justify-self: center;" href="javascript:void(0)"
        (click)="logout()">Salir</a>
    </div>

  </mat-toolbar>

  <mat-sidenav-container class="sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="mobileQuery.matches"
      fixedTopGap="56">
      <div class="sidenav">

        <!-- Candidates section -->
        <app-canditates-sidenav></app-canditates-sidenav>

        <app-recruiter-sidenav *ngIf="role == 1"></app-recruiter-sidenav>

        <!-- Exams Section -->
        <mat-accordion>
          <mat-expansion-panel style="background-color: rgb(31, 33, 49);" hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Sección de examenes
              </mat-panel-title>
              <mat-panel-description>


              </mat-panel-description>
            </mat-expansion-panel-header>


            <mat-selection-list [multiple]="false">
              <mat-list-option>
                <a href="javascript:void(0)" (click)="createExam()">Crear nuevo examen</a>
              </mat-list-option>
              <!-- <mat-list-option>
                Examen 2
              </mat-list-option> -->
            </mat-selection-list>


          </mat-expansion-panel>
        </mat-accordion>

        <!-- Settings -->
        <mat-accordion>
          <mat-expansion-panel style="background-color: rgb(31, 33, 49);" hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Configuraciones
              </mat-panel-title>
              <mat-panel-description>


              </mat-panel-description>
            </mat-expansion-panel-header>


            <mat-selection-list [multiple]="false">
              <mat-list-option>
                Configuracion 1
              </mat-list-option>
              <mat-list-option>
                Configuracion 2
              </mat-list-option>
            </mat-selection-list>


          </mat-expansion-panel>
        </mat-accordion>



      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>